import type { EnvironmentalCondition, EnvironmentalAspectStatus } from './types';

export const LIFECYCLE_STAGE_OPTIONS = [
  { value: '', label: 'Todas las etapas' },
  { value: 'adquisicion', label: 'Adquisición de materias primas' },
  { value: 'produccion', label: 'Producción' },
  { value: 'distribucion', label: 'Distribución' },
  { value: 'uso', label: 'Uso' },
  { value: 'fin_vida', label: 'Fin de vida' },
  { value: 'sin_clasificar', label: 'Sin clasificar' },
] as const;

export const LIFECYCLE_STAGE_LABEL: Record<string, string> = {
  adquisicion: 'Adquisición',
  produccion: 'Producción',
  distribucion: 'Distribución',
  uso: 'Uso',
  fin_vida: 'Fin de vida',
  sin_clasificar: 'Sin clasificar',
};

export const CONDITION_LABEL: Record<EnvironmentalCondition, string> = {
  normal: 'Normal',
  anormal: 'Anormal',
  emergencia: 'Emergencia',
};

export const STATUS_LABEL: Record<EnvironmentalAspectStatus, string> = {
  identificado: 'Identificado',
  evaluado: 'Evaluado',
  controlado: 'Controlado',
  baja: 'Baja',
};

export function significanceBadgeClass(
  significant: boolean,
  score: number,
  threshold: number,
): string {
  if (significant) return 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200';
  if (score >= threshold * 0.75) {
    return 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200';
  }
  return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200';
}

export function significanceLabel(
  significant: boolean,
  score: number,
  threshold: number,
): string {
  if (significant) return `Significativo (${score})`;
  if (score >= threshold * 0.75) return `Moderado (${score})`;
  return `No significativo (${score})`;
}

export function statusBadgeClass(status: EnvironmentalAspectStatus): string {
  switch (status) {
    case 'controlado':
      return 'bg-emerald-100 text-emerald-800';
    case 'evaluado':
      return 'bg-amber-100 text-amber-800';
    case 'baja':
      return 'bg-gray-100 text-gray-600';
    default:
      return 'bg-sky-100 text-sky-800';
  }
}

export function conditionBadgeClass(condition: EnvironmentalCondition): string {
  switch (condition) {
    case 'emergencia':
      return 'bg-red-100 text-red-800';
    case 'anormal':
      return 'bg-amber-100 text-amber-800';
    default:
      return 'bg-slate-100 text-slate-700';
  }
}
